module.exports = __webpack_public_path__ + "static/media/round13.3e98b9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round13.png
// module id = 1164
// module chunks = 0